const KEY = 'argus.pendingClubWarInvite.v1'
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000

export function rememberPendingClubWarInvite(token) {
  const value = String(token ?? '').trim()
  if (value.length < 32 || value.length > 200) return false
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ token: value, saved_at: Date.now() }))
    window.dispatchEvent(new CustomEvent('argus:pending-club-war-invite'))
    return true
  } catch {
    return false
  }
}

export function readPendingClubWarInvite() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) ?? 'null')
    if (!parsed?.token || typeof parsed.saved_at !== 'number') return null
    if (Date.now() - parsed.saved_at > MAX_AGE_MS) {
      window.localStorage.removeItem(KEY)
      return null
    }
    return parsed.token
  } catch {
    return null
  }
}

export function clearPendingClubWarInvite() {
  try {
    window.localStorage.removeItem(KEY)
    window.dispatchEvent(new CustomEvent('argus:pending-club-war-invite'))
  } catch {
    // Persistence is a convenience. The server invite ledger remains authoritative.
  }
}
